import currency from 'currency.js';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Shanghai');

export function formatNumber(n: number | string) {
  return currency(n, { separator: ',', symbol: '' }).format();
}

export function formatCreatedAt(n: number, isUnix = false, template = 'YYYY-MM-DD HH:mm:ss') {
  if (isUnix) {
    return dayjs.unix(n).tz().format(template);
  }
  return dayjs
    .unix(n / 1000000000)
    .tz()
    .format(template);
}

export function dateFromUnix(unix: number) {
  return dayjs.unix(unix);
}

export function strToUnix(date: string) {
  return dayjs(date).tz().unix();
}

export function strToUnix2(date: string, format = 'YYYY-MM-DD HH:mm:ss') {
  return dayjs.tz(date, format, 'Asia/Shanghai').unix();
}

// 将字符串时间转为 0 点时间戳
export function strToDayUnix(date: string) {
  return dayjs(date).tz().startOf('day').unix();
}

export function currentDayjs() {
  return dayjs().tz();
}

export function currentDay() {
  return dayjs().tz().format('YYYY-MM-DD');
}
